<!-- Template for a new page -->
<template>
	<div class="d-flex flex-column flex h-100">
		<navbar></navbar>
		<div class="app">
			<reporting-sidenav></reporting-sidenav>
			<div id="content" class="app-content box-shadow-3 d-flex flex flex-column scroll-x">
				<!-- Optional navbar at top of page -->
				<div class="navbar navbar-light bg-light b-b flex-nowrap flex-fixed">
					<div class="navbar-text nav-title flex" id="pageTitle">
						Reporting
						<span class="far fa-fw fa-angle-right"></span>User Agreement
					</div>
				</div>

				<div class="d-flex flex-column flex scroll-x scroll-y">
					<div class="row mx-0 px-3 pt-3 box no-shrink">
						<div class="col-12 col-sm-6 col-lg-4">
							<div class="form-group">
								<label>Content Area</label>
								<config-select
									:nullOption="true"
									nullText="Any"
									:options="contentAreas"
									v-model="selectedCA"
								></config-select>
							</div>
						</div>
						<div class="col-12 col-sm-6 col-lg-4">
							<div class="form-group">
								<label>Grade</label>
								<config-select
									:nullOption="true"
									nullText="Any"
									sortBy="sequence"
									:options="grades"
									v-model="selectedGrade"
								></config-select>
							</div>
						</div>
						<div class="col-12 col-sm-6 col-lg-4">
							<div class="form-group">
								<label>Assessment</label>
								<config-select
									:nullOption="true"
									nullText="None"
									:options="filteredAssessments"
									v-model="selectedAsmt"
								></config-select>
							</div>
						</div>
						<div class="col-12 d-flex flex-row align-items-end justify-content-end">
							<div class="d-flex flex-row align-items-center form-group">
								<!-- <button
									v-if="reportStats && reportStats.length > 0"
									class="btn btn-sm btn-icon btn-rounded theme-accent mx-1"
									style="padding-top: 10px;"
									v-tippy
									title="Export..."
									data-toggle="dropdown"
									aria-expanded="false"
								>
									<i class="fas fa-file-export" style="margin-left: 2px;"></i>
								</button>
								<div
									v-if="reportStats && reportStats.length > 0"
									class="dropdown-menu dropdown-menu-right w-md"
								>
									<a class="dropdown-item" @click="dlPdf()">
										<i class="far fa-file-pdf fa-fw fa-lg"></i>
										<label class="mb-0">Export to PDF</label>
									</a>
									<a class="dropdown-item" @click="dlPdfWithTraits()">
										<i class="far fa-file-pdf fa-fw fa-lg"></i>
										<label class="mb-0">
											Export to PDF
											<span class="text-muted">(detailed)</span>
										</label>
									</a>
									<a class="dropdown-item" @click="dlCsv()">
										<i class="far fa-file-excel fa-fw fa-lg"></i>
										<label class="mb-0">Export to CSV</label>
									</a>
									<a class="dropdown-item" @click="dlCsvWithTraits()">
										<i class="far fa-file-excel fa-fw fa-lg"></i>
										<label class="mb-0">
											Export to CSV
											<span class="text-muted">(detailed)</span>
										</label>
									</a>
								</div>-->
								<div class="py-0 ml-1">
									<button
										@click="getStats"
										class="btn btn-sm btn-block flex-fixed"
										:class="{ [canRun ? 'theme-accent' : 'btn-secondary']: true }"
										:disabled="!canRun"
										v-b-tooltip
										title="Run Report"
									>
										<i v-if="!running" class="far fa-clipboard-list"></i>
										<loading v-if="running" type="icon" />
										<span class="hidden-folded d-inline">&nbsp;Run Report</span>
									</button>
								</div>
							</div>
						</div>
					</div>

					<div
						v-if="reportStats && reportStats.length > 0"
						class="flex d-flex flex-row box-shadow-3 pb-3 scroll-y scroll-x"
						style="min-height: 100px;"
					>
						<div class="flex">
							<div class="card border-0">
								<report-table
									class="condensed-table mb-0"
									:fields="fields"
									:totals="reportTotals"
									:content="reportStats"
									totalsClass="theme-lighten-3 text-on-color"
								>
									<!-- Scorer -->
									<template slot="scorer" slot-scope="data">
										<a
											v-if="!isTotalRow(data.item)"
											@click="toggleExpand(data)"
											class="float-right btn-subtle"
										>
											<i
												v-if="!data.item.expand"
												class="far fa-plus"
												v-tippy
												title="Show details"
											></i>
											<i
												v-if="data.item.expand"
												class="far fa-minus"
												v-tippy
												title="Hide details"
											></i>
										</a>
										<span v-if="!data.item.user">{{ data.item.scorer }}</span>
										<span
											v-if="data.item.user"
											v-tippy
											:title="data.item.user.scorer_id != '' ? data.item.user.full_name : null"
											>{{ fs.scorerID(data.item.user) }}</span
										>
										<div v-show="data.item.expand">
											<div v-for="trait in data.item.traits" :key="trait.trait_id" class="nowrap">
												<span v-if="!trait.separator" class="text-muted px-1">•</span>
												<span :class="{ 'text-muted': trait.separator }">{{
													trait.trait_name
												}}</span>
											</div>
										</div>
									</template>

									<!-- IRR Exact -->
									<template slot="irr_exact_percent" slot-scope="data">
										<span :class="{ 'text-very-muted': data.item.irr_total == 0 }">{{
											fs.fixedPercent1d(data.item.irr_exact_percent)
										}}</span>
										<div v-show="data.item.expand && data.item.irr_total > 0">
											<div v-for="trait in data.item.traits" :key="trait.trait_id">
												<span v-if="!trait.separator" class="text-muted px-1">•</span>
												<span v-if="!trait.separator">{{
													fs.fixedPercent1d(trait.irr_exact_percent)
												}}</span>
												<span v-if="trait.separator" class="text-muted px-1">&nbsp;</span>
											</div>
										</div>
									</template>
									<template slot="HEAD_irr_exact_percent" slot-scope="data">
										<div>{{ data.label }}</div>
										<div class="text-muted _400">{{ data.field.sublabel }}</div>
									</template>
									<!-- IRR Exact or Adjacent -->
									<template slot="irr_exact_adj_percent" slot-scope="data">
										<span :class="{ 'text-very-muted': data.item.irr_total == 0 }">{{
											fs.fixedPercent1d(data.item.irr_exact_adj_percent)
										}}</span>
										<div v-show="data.item.expand && data.item.irr_total > 0">
											<div v-for="trait in data.item.traits" :key="trait.trait_id">
												<span v-if="!trait.separator" class="text-muted px-1">•</span>
												<span v-if="!trait.separator">{{
													fs.fixedPercent1d(trait.irr_exact_adj_percent)
												}}</span>
												<span v-if="trait.separator" class="text-muted px-1">&nbsp;</span>
											</div>
										</div>
									</template>
									<template slot="HEAD_irr_exact_adj_percent" slot-scope="data">
										<div>{{ data.label }}</div>
										<div class="text-muted _400">{{ data.field.sublabel }}</div>
									</template>

									<!-- Validity normal agreement -->
									<template slot="val_exact_percent" slot-scope="data">
										<span :class="{ 'text-very-muted': data.item.val_total == 0 }">{{
											fs.fixedPercent1d(data.item.val_exact_percent)
										}}</span>
										<div v-show="data.item.expand && data.item.val_total > 0">
											<div v-for="trait in data.item.traits" :key="trait.trait_id">
												<span class="text-muted px-1">•</span>
												{{ fs.fixedPercent1d(trait.val_exact_percent) }}
											</div>
										</div>
									</template>
									<template slot="HEAD_val_exact_percent" slot-scope="data">
										<div>{{ data.label }}</div>
										<div class="text-muted _400">{{ data.field.sublabel }}</div>
									</template>
									<!-- Validity full agreement -->
									<template slot="val_exact_adj_percent" slot-scope="data">
										<span :class="{ 'text-very-muted': data.item.val_total == 0 }">{{
											fs.fixedPercent1d(data.item.val_exact_adj_percent)
										}}</span>
										<div v-show="data.item.expand && data.item.val_total > 0">
											<div v-for="trait in data.item.traits" :key="trait.trait_id">
												<span class="text-muted px-1">•</span>
												{{ fs.fixedPercent1d(trait.val_exact_adj_percent) }}
											</div>
										</div>
									</template>
									<template slot="HEAD_val_exact_adj_percent" slot-scope="data">
										<div>{{ data.label }}</div>
										<div class="text-muted _400">{{ data.field.sublabel }}</div>
									</template>

									<!-- Resolution required -->
									<template slot="res_required_percent" slot-scope="data">
										<span :class="{ 'text-very-muted': data.item.res_total == 0 }">{{
											fs.fixedPercent1d(data.item.res_required_percent)
										}}</span>
										<div v-show="data.item.expand && data.item.res_total > 0" class="text-muted">
											{{ data.item.res_required }} out of {{ data.item.res_total }}
										</div>
									</template>
									<template slot="HEAD_res_required_percent" slot-scope="data">
										<div>{{ data.label }}</div>
										<div class="text-muted _400">{{ data.field.sublabel }}</div>
									</template>
									<!-- Resolution disagreed -->
									<template slot="res_changed_percent" slot-scope="data">
										<span :class="{ 'text-very-muted': data.item.res_total == 0 }">{{
											fs.fixedPercent1d(data.item.res_changed_percent)
										}}</span>
										<div v-show="data.item.expand && data.item.res_total > 0" class="text-muted">
											{{ data.item.res_changed }} out of {{ data.item.res_total }}
										</div>
									</template>
									<template slot="HEAD_res_changed_percent" slot-scope="data">
										<div>{{ data.label }}</div>
										<div class="text-muted _400">{{ data.field.sublabel }}</div>
									</template>
								</report-table>
							</div>
						</div>
					</div>
					<div v-if="reportStats && reportStats.length == 0" class="d-flex flex-row justify-content-center">
						<h3 class="text-muted">Report returned no results</h3>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.d-long {
	display: none;
}
.d-abr {
	display: table-cell;
}
@media (min-width: 1100px) {
	.d-long {
		display: table-cell;
	}
	.d-abr {
		display: none;
	}
}
.unconstrained {
	width: auto;
	max-width: none;
	min-width: 100%;
}
i[class*="ion-"],
i[class*=" ion-"] {
	font-size: inherit;
	vertical-align: inherit;
}
a.btn-subtle i {
	opacity: 0.35;
	transition: opacity 0.25s;
}
a.btn-subtle:hover i {
	opacity: 1;
}
.trait-table tr {
	background-color: unset !important;
}
.trait-table td {
	border-top: unset;
}
</style>

<script>
//Libraries

//Services
import ReportingService from "@/services/ReportingService";
import ConfigService from "@/services/ConfigService";
import notie from "@/services/NotieService";
import store from "@/services/Store";
import fs from "@/services/FormatService";
import FileService from "@/services/FileService";
import moment from "moment";
import BB from "bluebird";

import ConfigSelect from "@/components/ConfigSelect";
import ReportTable from "@/components/ReportTable";

export default {
	name: "ReportUserAgreement",

	props: ["user"],

	components: { ConfigSelect, ReportTable },

	data() {
		return {
			fs: fs,

			fields: [
				{
					key: "margin-left",
					label: "",
					tdClass: "t-margin"
				},
				{
					key: "scorer",
					label: "Scorer",
					tdClass: "",
					thClass: "",
					sortable: true
				},
				{
					key: "irr_exact_percent",
					label: "IRR",
					sublabel: "(exact)",
					tdClass: "table-border-left",
					thClass: "table-border-left",
					sortable: true
				},
				{
					key: "irr_exact_adj_percent",
					label: "IRR",
					sublabel: "(exact/adjacent)",
					tdClass: "",
					thClass: "",
					sortable: true
				},

				{
					key: "res_required_percent",
					label: "Resolution",
					sublabel: "Required",
					tdClass: "v-mid",
					thClass: "v-mid",
					sortable: true
				},
				{
					key: "res_changed_percent",
					label: "Resolution",
					sublabel: "Disagreed",
					tdClass: "v-mid",
					thClass: "v-mid",
					sortable: true
				},
				{
					key: "margin-right",
					label: "",
					tdClass: "t-margin"
				}
			],
			userStats: null,

			reportStats: null,
			totalStats: null,
			showIncomplete: true,

			contentAreas: [],
			selectedCA: null,

			grades: [],
			selectedGrade: null,

			assessments: [],
			selectedAsmt: null,

			loading: true,
			running: false
		};
	},

	created() {
		this.storagePrefix = "user_agreement.";
		this.showIncomplete = store.bind(this, "showIncomplete");

		if (store.get(this, "user_agreement.auto")) {
			this.running = true;
		}

		BB.props({
			contentAreas: ConfigService.listContentAreas(),
			grades: ConfigService.listGrades(),
			assessments: ConfigService.listAssessments()
		})
			.then(resps => {
				this.contentAreas = resps.contentAreas.data.content_areas;
				this.grades = resps.grades.data;
				this.assessments = resps.assessments.data.assessments;

				this.selectedCA = store.bindFromList(this, this.contentAreas, "id", null, "selectedCA");
				this.selectedGrade = store.bindFromList(this, this.grades, "id", null, "selectedGrade");
				this.selectedAsmt = store.bindFromList(this, this.assessments, "id", null, "selectedAsmt");
			})
			.catch(err => {
				console.log(err);
				notie.error("Failed to load config options", err);
			})
			.finally(() => {
				this.loading = false;
			});
	},

	watch: {
		selectedCA() {
			if (this.selectedCA && this.selectedAsmt && this.selectedAsmt.content_area_id != this.selectedCA.id) {
				this.selectedAsmt = null;
			}
		},
		selectedGrade() {
			if (this.selectedGrade && this.selectedAsmt) {
				let found = false;
				_.each(this.selectedAsmt.grade_ids, gid => {
					if (this.selectedGrade.id == gid) {
						found = true;
					}
				});
				if (!found) {
					this.selectedAsmt = null;
				}
			}
		}
	},

	computed: {
		filteredAssessments() {
			if (!this.selectedCA && !this.selectedGrade) {
				return this.assessments;
			}
			return _.filter(this.assessments, asmt => {
				let matchedCA = true;
				if (this.selectedCA) {
					matchedCA = this.selectedCA.id == asmt.content_area_id;
				}
				let matchedGrade = true;
				if (this.selectedGrade) {
					matchedGrade = false;
					_.each(asmt.grade_ids, gid => {
						if (this.selectedGrade.id == gid) {
							matchedGrade = true;
						}
					});
				}

				return matchedCA && matchedGrade;
			});
		},

		canRun() {
			return this.selectedAsmt;
		}
	},

	methods: {
		getStats() {
			if (this.running) {
				return;
			}

			if (!this.canRun) {
				return;
			}

			this.running = true;
			ReportingService.getAgreementUsers(this.selectedAsmt.id)
				.then(resp => {
					this.reportStats = resp.data.stats;
					this.reportTotals = resp.data.totals;
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.running = false;
				});
		},

		constructTable() {
			let totals = {
				irr_exact: 0,
				irr_exact_adj: 0,
				val_exact: 0,
				val_exact_adj: 0,
				res_required: 0,
				res_changed: 0
			};
			let num = 0;

			_.each(this.userStats, stat => {
				num++;
				stat.scorer = fs.scorerID(stat.user);
				totals.irr_exact += stat.irr_exact;
				totals.irr_exact_adj += stat.irr_exact_adj;
				totals.val_exact += stat.val_exact;
				totals.val_exact_adj += stat.val_exact_adj;
				totals.res_required += stat.res_required;
				totals.res_changed += stat.res_changed;
			});

			totals.scorer = `Totals (${num})`;
			totals.irr_exact /= num;
			totals.irr_exact_adj /= num;
			totals.val_exact /= num;
			totals.val_exact_adj /= num;
			totals.res_required /= num;
			totals.res_changed /= num;

			this.reportStats = this.userStats;
			this.reportTotals = totals;
		},

		showStat(stat, i, set) {
			if (this.showIncomplete) {
				return stat.validityComplete[i] > 0;
			} else {
				return stat.validityComplete[i] == set.responses;
			}
		},

		fillItem(row) {
			//real
			let section = _.find(this.sections, { id: row.section_id });

			//mockup
			section = this.sections[0];

			if (section && section.items) {
				//real
				let item = _.find(section.items, { id: row.item_id });

				//mockup
				item = section.items[0];

				if (item) {
					this.selectedSection = section;
					this.selectedItem = item;
					this.getStats();
				}
			}
		},

		isTotalRow(item) {
			if (item.forceHead || item.forceFoot) {
				return true;
			} else {
				return false;
			}
		},

		toggleExpand(data) {
			this.$set(data.item, "expand", !data.item.expand);
		},

		dlPdf() {
			FileService.userAgreementReportPDF(this, false);
		},

		dlCsv() {
			FileService.userAgreementReportCSV(this, false);
		},

		dlPdfWithTraits() {
			FileService.userAgreementReportPDF(this, true);
		},

		dlCsvWithTraits() {
			FileService.userAgreementReportCSV(this, true);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/vues/QualityMgmt/ReportUserAgreement.vue